import axios from '../helpers/axiosConfig';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function ModifierCompagnie() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [compagnie, setCompagnie] = useState({
    name: '',
    libelle: '',
    reference: '',
    bataillonId: '',
  });
  const [bataillons, setBataillons] = useState([]);

  useEffect(() => {
    // Récupérer la liste des bataillons
    axios
      .get('/bataillon')
      .then((res) => setBataillons(res.data))
      .catch((error) => console.error('Erreur lors de la récupération des bataillons:', error));

    // Récupérer les données de la compagnie
    axios
      .get(`compagnie/edit/${id}`)
      .then((res) => setCompagnie(res.data.compagnie))
      .catch((error) => console.error('Erreur lors de la récupération de la compagnie:', error));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompagnie({ ...compagnie, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`compagnie/${id}`, compagnie)
      .then((response) => {
        toast.success(response.data.message);
        navigate('/compagnie');
      })
      .catch((error) => toast.error(error.response.data.error));
  };

  return (
    <div className="container mt-5 pt-4">
      <h2>Modifier la Compagnie</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nom:</label>
          <input type="text" name="name" value={compagnie.name} onChange={handleChange} required className="form-control" />
        </div>
        <div>
          <label>Libellé:</label>
          <input type="text" name="libelle" value={compagnie.libelle} onChange={handleChange} className="form-control" />
        </div>
        <div>
          <label>Référence:</label>
          <input type="text" name="reference" value={compagnie.reference} onChange={handleChange} className="form-control" />
        </div>
        <div>
          <label>Bataillon:</label>
          <select name="bataillonId" value={compagnie.bataillonId} onChange={handleChange} required className="form-control">
            <option value="">Sélectionner un bataillon</option>
            {bataillons.map((bataillon) => (
              <option key={bataillon.id} value={bataillon.id}>
                {bataillon.name} 
              </option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary">
          Modifier
        </button>
      </form>
    </div>
  );
}

export default ModifierCompagnie;
